const APP_DOMAIN = "nazare.app";
const DEV_APP_DOMAIN = `dev.${APP_DOMAIN}`;

function assertNazareHostname(hostname: string): void {
  if (hostname !== APP_DOMAIN && !hostname.endsWith(`.${APP_DOMAIN}`)) {
    throw new Error(`Unsupported Nazare app hostname: "${hostname}".`);
  }
}

function deploymentAppDomain(hostname: string): string {
  assertNazareHostname(hostname);
  return hostname === DEV_APP_DOMAIN || hostname.endsWith(`.${DEV_APP_DOMAIN}`) ? DEV_APP_DOMAIN : APP_DOMAIN;
}

export function deriveApiDomain(appUrl: string): string {
  const url = new URL(appUrl);
  assertNazareHostname(url.hostname);
  url.hostname = `api.${deploymentAppDomain(url.hostname)}`;
  url.pathname = "";
  url.search = "";
  url.hash = "";
  return url.origin;
}

export function resolveApiDomain(appUrl: string, override?: string): string {
  return override ? new URL(override).origin : deriveApiDomain(appUrl);
}

export function deriveAuthAppUrl(appUrl: string): string {
  const url = new URL(appUrl);
  assertNazareHostname(url.hostname);
  url.hostname = `auth.${deploymentAppDomain(url.hostname)}`;
  url.pathname = "";
  url.search = "";
  url.hash = "";
  return url.origin;
}

export function resolveAuthAppUrl(appUrl: string, override?: string): string {
  return override ? new URL(override).origin : deriveAuthAppUrl(appUrl);
}
